import React from 'react';
import PropTypes from 'prop-types';
import { ALL_ROWS_LABEL } from '../../mme/MMEConstants';

const cellArray = ['s0', 's1', 's2', 's3'];

const MMEDCRCellContent = ({ cell, rowHeader, index }) => {
  return (
    <div className="c-table--col">
      <div className="cell-content" style={{ display: 'flex' }}>
        {rowHeader !== ALL_ROWS_LABEL && cellArray.map(item => (
          <div key={item} className="cell-value" style={{ flex: '1' }}>
          <div
            className="mme-cell-text"
            title={`${cell[item]}%`}
            style={{ color: '#333', fontWeight: '400' }}
            data-class={`${item}${index}`}
          >{`${cell[item]}%`}</div>
        </div>))}
      </div>
    </div>
  );
};

MMEDCRCellContent.propTypes = {
  cell: PropTypes.shape({}),
  rowHeader: PropTypes.string,
  highlightAndFilter: PropTypes.shape({
    sample: PropTypes.shape({}),
    weighted: PropTypes.shape({}),
    vertical: PropTypes.shape({}),
    horizontal: PropTypes.shape({}),
    index: PropTypes.shape({}),
  }),
  newHighlightAndFilter: PropTypes.shape({}),
  index: PropTypes.number,
};

export default MMEDCRCellContent;
